import { Pipe, PipeTransform } from '@angular/core';
import { FilterSetService, FilterSet } from '../services/filter-set.service';

@Pipe({name: 'filterSetUrl'})

export class FilterSetUrlPipe implements PipeTransform {

	constructor(private filterSetService: FilterSetService) { }

	transform(filterSet: FilterSet): string {
		return this.filterSetService.stringify(filterSet);
	}
}
